import React from "react";

export default class TextInput extends React.Component {

    constructor (props){
        super(props);

        this.state = {
            value: this.props.value
        }
    }

    handleChange(event) {
        this.setState({value: event.target.value});
        if (this.props.onChange)
            this.props.onChange(event.target.value)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
          this.setState({value: this.props.value})
        }
      }

    render () {

        const passwordFlag = this.props.type != undefined ? this.props.type == "password" : false;
        const readOnly = this.props.readOnly != undefined && this.props.readOnly == true ? true : false;

        if (readOnly == true){
            return (
                <div style={mainClass}>
                    <div style={name}>{this.props.name}</div>
                    <input type={passwordFlag == true ? "password" : "text"} style={{...inputTextDisabled, borderLeft: 0, borderTop: 0, borderRight: 0, borderBottom: '1px solid darkgrey', backgroundColor: '#EEEEEE', ...this.props.style}} readOnly value={this.state.value ? this.state.value : this.props.value} onChange={this.handleChange.bind(this)} autoComplete={this.props.autocomplete ? this.props.autocomplete : "true"}></input>
                </div>
            );
        }

        return ( 
            <div style={mainClass}>
                <div style={name}>{this.props.name}</div>
                <input type={passwordFlag == true ? "password" : "text"} name={this.props.name} placeholder={this.props.placeholder ? this.props.placeholder : ''} style={{width: this.props.width != undefined ? this.props.width : '300px', padding: '10px', borderTop: 0, borderLeft: 0, borderRight: 0, borderBottom: '1px solid darkgrey', backgroundColor: '#EEEEEE', ...this.props.style }} value={this.state.value != undefined ? this.state.value : this.props.value} onChange={this.handleChange.bind(this)}></input>
            </div>
        );
    }


}

const mainClass = {
    padding: '5px',
}

const name = {
    
}


const inputTextDisabled = {
    background: '#eeeeee',
    width: '300px',
    padding: '10px'
}